"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverrideTypes = exports.overrideExists = void 0;
exports.overrideExists = (name, overrides) => overrides[name] !== undefined;
exports.OverrideTypes = {
    boolean: (overrideString) => {
        if (overrideString === 'null') {
            return null;
        }
        return overrideString.toLowerCase() !== 'false';
    },
    string: (overrideString) => {
        if (overrideString === 'null') {
            return null;
        }
        return overrideString;
    },
    float: (overrideString) => {
        if (overrideString === 'null') {
            return null;
        }
        return parseFloat(overrideString);
    },
    int: (overrideString) => {
        if (overrideString === 'null') {
            return null;
        }
        return parseInt(overrideString, 10);
    },
};
//# sourceMappingURL=overrideUtils.js.map